import { render, staticRenderFns } from "./exchangeOrder.vue?vue&type=template&id=48206a93&scoped=true&"
import script from "./exchangeOrder.vue?vue&type=script&lang=js&"
export * from "./exchangeOrder.vue?vue&type=script&lang=js&"
import style0 from "./exchangeOrder.vue?vue&type=style&index=0&id=48206a93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48206a93",
  null
  
)

export default component.exports